import React, { useEffect, useState } from 'react';

const PaymentSuccess = () => {
  useEffect(() => {
    // Extract session_id from URL (Stripe automatically appends this)
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    // Also check for payment_intent_id if available
    const paymentIntentId = urlParams.get('payment_intent');
    
    // Use session_id as transaction_id, fallback to payment_intent_id
    const txId = sessionId || paymentIntentId || '';

    // Track Google Ads conversion
    if (window.gtag && txId) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17731531595/TAQOCJjX6cAbEMvmhodC',
        'transaction_id': txId
      });
    }
  }, []);

  const handleGoToRedeem = () => {
    window.location.href = '/redeem';
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="glass-card text-center" style={{ padding: '3rem 2rem' }}>
            <div className="mb-4">
              <i className="bi bi-check-circle-fill" style={{ fontSize: '5rem', color: '#10b981' }}></i>
            </div>
            
            <h1 className="commercial-heading mb-4" style={{ color: '#000000' }}>
              Thank You For Your Purchase!
            </h1>
            
            <div className="mb-4" style={{ fontSize: '1.1rem', color: '#000000', lineHeight: '1.8' }}>
              <p className="mb-3">
                Your payment has been successfully processed.
              </p>
              
              <div className="alert alert-info" style={{ 
                background: 'rgba(30, 64, 175, 0.1)', 
                border: '1px solid rgba(30, 64, 175, 0.3)',
                color: '#1e40af',
                borderRadius: '12px',
                padding: '1.5rem',
                margin: '2rem 0'
              }}>
                <i className="bi bi-envelope-check-fill me-2" style={{ fontSize: '1.5rem' }}></i>
                <strong>Check Your Email</strong>
                <p className="mb-0 mt-2" style={{ fontSize: '1rem' }}>
                  Your 5 redemption codes have been sent to the email address you provided during checkout.
                  Please check your inbox (and spam folder) for an email from ObitAuthor.
                </p>
              </div>
              
              <p className="mb-4" style={{ fontSize: '1rem' }}>
                You can use your codes anytime to generate professional obituaries. 
                Each code can be used once, and they never expire.
              </p>
            </div>

            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary btn-lg pulsate-btn"
                onClick={handleGoToRedeem}
                style={{ minWidth: '200px' }}
              >
                <i className="bi bi-key-fill me-2"></i>
                Go to Redemption Page
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;

